;(function () {
    window.Ateed.Components.CaseStudyCarousel = function($container) {

        $('.ateed-case-study-carousel').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            draggable: false,
            fade: true,
            infinite: true,
            speed: 500,
            swipe: false
        });

        $('.ateed-case-study-carousel-compact').slick({
            arrows: false,
            autoplay: true,
            autoplaySpeed: 3000,
            dots: true,
            draggable: false,
            fade: true,
            infinite: true,
            speed: 500,
            swipe: false,
            responsive: [
                {
                    breakpoint: 640,
                    settings: {
                        breakpoint: 640,
                        draggable: true,
                        swipe: true
                    }
                }
            ]
        });

        // initial load check, check if first slide has video
        var uploadedVideo = $('.region-banner .slick-active .banner_video video');
        if ($('.region-banner .slick-active .banner_video img').length>0 || uploadedVideo.length>0) {
          $('.region-banner-content .play_icon').removeClass('play_icon-hidden');
        }

        $('.region-banner-content .play_icon').click(function(){
          if ($('.region-banner .slick-active .banner_video img').length>0) {
            $('.region-banner .slick-active .banner_video img').click();
          }
          var uploadedVideo = $('.region-banner .slick-active .banner_video video');
          if (uploadedVideo.length>0) {
            var video = uploadedVideo[0];
            //uploadedVideo.css('width',video.videoWidth+'px');
            //uploadedVideo.css('height',video.videoHeight+'px');
            uploadedVideo.css('max-width','100%');
            uploadedVideo.css('max-height','100%');
            $.colorbox({'close':"Close",'current':"{current} of {total}",'fixed':true,'maxHeight':'98%','maxWidth':'98%','mobiledetect':true,'mobiledevicewidth':'480px','next':'Next »','opacity':'0.85','open':true,'previous':'« Prev',html: $('.region-banner .slick-active .banner_video .field--type-video .field--item').html(), onComplete: function(){ $('#cboxLoadedContent').find("video")[0].play(); } });
          }
        });

        $('.ateed-case-study-carousel').on('afterChange', function (slick, currentSlide) {
            // deselect all tags
            $('.ateed-case-study-tags li .test')
            .removeClass('active');
            // select tag with current index
            $('.ateed-case-study-tags li:nth-child(' + (currentSlide.currentSlide + 1) + ') a[data-featured]')
            .addClass('active');
        })

        $('.ateed-case-study-carousel-compact').on('afterChange', function (slick, currentSlide) {
            // deselect all tags
            $('.ateed-case-study-tags li.compact')
            .removeClass('active');
            // select tag with current index
            $('.ateed-case-study-page-tag.compact:nth-child(' + (currentSlide.currentSlide + 1) + ')')
            .addClass('active');

            if ($('.region-banner').find('.slick-slide:nth-child('+(currentSlide.currentSlide + 1)+') .banner_video').length>0) {
              $('.region-banner-content .play_icon').removeClass('play_icon-hidden')
            }
            else {
              $('.region-banner-content .play_icon').addClass('play_icon-hidden')
            }
        })

        function captionLeft () {

            if ($('.ateed-case-study-carousel-compact').slick('getSlick').slideCount > 1) {
                return $('.ateed-case-study-carousel-compact').slick('getSlick').slideCount * 20 + 30
            }
            else {
                return 20
            }
        }

        $('.carousel-caption').css(
            'left',
            captionLeft()
        );

        if ($('.page-title-wrapper, .ateed-case-study-contents').length === 0) {
            // remove panel-connector at the top of the content if there is no page title or carousel block
            $('.region-content-wrapper').addClass('no-header');
        }

        //
        // Home page - Parallax for carousel
        //
        window.requestAnimationFrame = window.requestAnimationFrame
        || window.mozRequestAnimationFrame
        || window.webkitRequestAnimationFrame
        || window.msRequestAnimationFrame
        || function (f) { setTimeout(f, 1000 / 60) }

        var depth1 = $('.slick-list, .ateed-case-study-contents'),
            depth2 = $('.slick-dots'),
            depth3 = $('.region-content-wrapper'),
            wrapper = $('.ateed-body-copy'),
            wrapperHeight = wrapper.height(),
            scrollSpeed1 = .3,
            scrollSpeed2 = .5,
            scrollSpeed3 = .9;

        function parallaxLayers(){
            var scrolltop = window.pageYOffset // get number of pixels document has scrolled vertically
            depth1.css('top', -scrolltop * scrollSpeed1 + 'px'); // move depth1 at 30% of scroll rate
            depth2.css('top', -scrolltop * scrollSpeed2 + 'px'); // move depth1 at 60% of scroll rate
            depth3.css('top', -scrolltop * scrollSpeed3 + 'px'); // move depth1 at 90% of scroll rate
            // update wrapper height relative to parallax scroll
            wrapper.height(wrapperHeight - (scrolltop * scrollSpeed3));
        }

        if (
            $('body').hasClass('page-node-type-home-page') &&
            navigator.userAgent.indexOf('Firefox') < 0
        ) {
            /*window.addEventListener('scroll', function () {
                requestAnimationFrame(parallaxLayers)
            }, false)*/
        }
        else {
            window.removeEventListener('scroll', function () {
                requestAnimationFrame(parallaxLayers)
            }, false)
        }

        function handleRender () {
            depth1 = $('.slick-list, .ateed-case-study-contents');
            depth2 = $('.slick-dots');
            depth3 = $('.region-content-wrapper');
            depth1.css('top', 0);
            depth2.css('top', 0);
            depth3.css('top', 0);
            wrapperHeight = depth3.height();

            if ($(window).width() > 768) {
                scrollSpeed2 = .5;
            }
            else if ($(window).width() > 640 && $(window).width() <= 768) {
                scrollSpeed2 = .6;
            }
            else if ($(window).width() <= 640) {
                scrollSpeed2 = .7;
            }
        }
        handleRender()
        $(window).resize(handleRender)

        $('.ateed-case-study-carousel-wrapper').show();
        $(window).resize();
    };
})();
